import { Play } from "lucide-react";
import { MaskReveal, Reveal } from "./Reveal";
import { BUSINESS } from "./data";

const buildSrc = (url) => {
  const params =
    "color=%23d4af37&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true";
  return `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&${params}`;
};

export const Mixes = () => {
  return (
    <section id="mixes" className="relative bg-ink-950 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="mb-16 flex flex-col justify-between gap-6 md:mb-24 md:flex-row md:items-end">
          <div>
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ On SoundCloud</span>
            </Reveal>
            <h2 className="mt-5 font-oswald text-6xl font-700 uppercase leading-[0.85] tracking-tighter text-white md:text-8xl">
              <MaskReveal lines={["Latest", "Mixes"]} />
            </h2>
          </div>
          <Reveal delay={0.2}>
            <a
              data-testid="soundcloud-follow-btn"
              href={BUSINESS.soundcloud}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3.5 hover:border-gold transition-colors duration-500"
            >
              <Play size={14} className="fill-gold text-gold" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white group-hover:text-gold transition-colors duration-500">
                Follow on SoundCloud
              </span>
            </a>
          </Reveal>
        </div>

        <Reveal>
          <div
            data-testid="soundcloud-player"
            className="group relative overflow-hidden border border-white/5 bg-ink-900/60 p-4 backdrop-blur-2xl transition-colors duration-500 hover:border-gold/40 md:p-6"
          >
            <div className="mb-4 flex items-center justify-between md:mb-6">
              <div className="flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center border border-gold/40">
                  <Play size={16} className="fill-gold text-gold" />
                </span>
                <div>
                  <p className="font-oswald text-2xl font-600 uppercase tracking-tight text-white md:text-3xl">DJ Yung Jazzy</p>
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Full Catalogue · Live on SoundCloud</span>
                </div>
              </div>
              <span className="hidden font-mono text-xs text-zinc-600 md:block">@djyungjazzy-noulababy</span>
            </div>
            <div className="overflow-hidden border border-white/5">
              <iframe
                title="DJ Yung Jazzy on SoundCloud"
                width="100%"
                height="500"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src={buildSrc(BUSINESS.soundcloud)}
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
